import { lighten } from 'polished'

export const Colors = {
  green: 'rgba(45, 246, 213, 0.3)',
  rose: 'rgba(246,169,207,0.6)',
  bodyColor: 'hsla(0,0%,0%,0.8)',
  linkColor: lighten(0.1, '#109173'),
}
